import { forwardRef } from 'react';

import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import type { FeedProps, FeedImperativeHandle } from './types';
import FeedV1 from './v1';
import FeedWithPagination from './with-pagination';

const Feed = forwardRef<FeedImperativeHandle, FeedProps>((props, ref) => {
  const { flagUjbLfPagination } = useFeatureFlag();

  return !flagUjbLfPagination ? (
    <FeedV1 ref={ref} {...props} />
  ) : (
    <FeedWithPagination ref={ref} {...props} />
  );
});

export default Feed;
